import echart, { EChartOption, EChartsResponsiveOption, ECharts } from 'echarts'
import { getTitleStringByType, getEveryDayDateStringList } from '@/utils/date'

export const drawCompanyRechargehart = (chart: ECharts, data: any, filter: any) => {
  chart.setOption({
    title: {
      text: '车队充值数据'
    },
    tooltip: {
      trigger: 'axis',
      formatter: '{b}: {c}￥'
    },
    xAxis: {
      data: data.map((item: any) => {
        return `${item.year}-${item.month}`
      })
    },
    yAxis: {},
    series: [
      {
        type: 'line',
        markLine: {
          data: [{ type: 'average', name: '平均值' }]
        },
        data: data.map((item: any) => {
          return parseFloat(parseFloat(item.total).toFixed(2))
        })
      }
    ]
  })
}
